import { Box, Heading, Text, Flex, Button } from "@chakra-ui/react";
import { LiveBackground } from "../../components/motion";
import { BobContent } from "../../data/bobContent";

const scrollToDemo = () => {
  document.getElementById("bob-demo")?.scrollIntoView({ behavior: "smooth" });
};
const scrollToContact = () => {
  document.getElementById("bob-contact")?.scrollIntoView({ behavior: "smooth" });
};

const BobHero = ({ hero }: { hero: BobContent["hero"] }) => (
  <Box
    as="section"
    position="relative"
    bg="chalk.100"
    minH={{ base: "auto", md: "80vh" }}
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    color="ink.900"
    textAlign="center"
    overflow="hidden"
    pt={{ base: 16, md: 20 }}
    pb={{ base: 16, md: 16 }}
    px={5}
  >
    <LiveBackground variant="hero" tone="teal" />

    <Flex direction="column" align="center" position="relative" zIndex={1} maxW="820px">
      <Heading
        as="h1"
        fontFamily="heading"
        fontSize={{ base: "3xl", sm: "4xl", md: "6xl" }}
        lineHeight="1.1"
        letterSpacing="-0.02em"
        mb={5}
      >
        {hero.heading}{" "}
        <Box as="span" color="bob.300">
          {hero.highlight}
        </Box>{" "}
        {hero.headingEnd}
      </Heading>

      <Text fontSize={{ base: "md", md: "xl" }} color="slate.700" maxW="620px" mb={10}>
        {hero.subtitle}
      </Text>

      <Flex gap={4} direction={{ base: "column", sm: "row" }}>
        <Button
          size="lg"
          bg="bob.300"
          color="bob.900"
          fontWeight="bold"
          px={8}
          _hover={{ bg: "bob.200", transform: "translateY(-2px)" }}
          transition="all 0.2s ease"
          onClick={scrollToContact}
        >
          {hero.ctaPrimary}
        </Button>
        <Button
          size="lg"
          variant="outline"
          borderColor="chalk.500"
          color="ink.900"
          px={8}
          _hover={{ borderColor: "bob.300", color: "bob.300", bg: "chalk.200" }}
          onClick={scrollToDemo}
        >
          {hero.ctaSecondary}
        </Button>
      </Flex>
    </Flex>
  </Box>
);

export default BobHero;
